import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import _ from 'lodash';

@Component({
    selector: 'medpt-matrix',
    templateUrl: './matrix.component.html',
    styleUrls: ['./matrix.component.scss'],
    standalone: false
})
export class MatrixComponent implements OnInit {

  @Input() field: any = {};
  @Input() form!: FormGroup;
  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  matrixAnsData: any[] = [];
  constructor() { }

  ngOnInit(): void {
    this.matrixAnsData = this.getMatrixAnswers();
  }

  getMatrixAnswers() {

    let ans = this.field.MatrixQuestion.MatrixAnswers;
    let count = this.field.MatrixQuestion.VMatrixRows.MatrixElements.length;

    let record: any[] = [];

    for (var i = 0; i < count; i++) {
      const sliced = _.filter(ans, (item) => { return item.AnswerDefOrdinal == i + 1; });
      record.push({ index: i, answers: sliced });
    }
    return record;
  }

  onCheckboxChange(e: any) {
    const checkArray: FormArray = this.form.get(this.field.uniquename) as FormArray;
    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

}
